import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { IEarning } from '../model';
import { namespace } from '../namespace';

interface TState {
  earnings: IEarning[];
  interval: { from?: Date; to?: Date };
}

const initialState: TState = {
  earnings: [],
  interval: { from: undefined, to: undefined },
};

const earningsSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {
    setEarnings: (
      state,
      action: PayloadAction<{ earnings: IEarning[]; interval: { from: Date; to: Date } }>,
    ) => {
      state.earnings = action.payload.earnings;
      state.interval = action.payload.interval;
    },
  },
});

export { earningsSlice, namespace as earningsNamespace };
